import { Injectable } from '@angular/core';
import { CreateTransferCalendarDialogComponent } from '../dialogs/transfers/create-transfer-calendar/create-transfer-calendar.dialog';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CreateTransferDialogComponent } from '../dialogs/transfers/create-transfer/create-transfer.dialog';
import { AlfrescoApiService } from '@alfresco/adf-core';
import { UdeuTransferCalendar } from '../model/classes/udeu-transfer-calendar';
import { TransferActionTypes } from '../store/actions/transfer-actions';
import { UdeuCreateTransfer, UdeuTransfer } from '../model/classes/udeu-transfer';
import { NodePaging } from '@alfresco/js-api';
import { SYS_NODE_UUID_PROP, } from '../model/contants/deusto';

@Injectable({
  providedIn: 'root'
})
export class TransferService {
  constructor(public dialog: MatDialog, private alfrescoApiService: AlfrescoApiService) { }

  openCreateTransferCalendar(): MatDialogRef<CreateTransferCalendarDialogComponent> {
    return this.dialog.open(CreateTransferCalendarDialogComponent,
      {
        disableClose: true,
        autoFocus: true,
        width: '80%',
        maxHeight: '90%', 
      },
    );
  }

  openTransferCalendarDialog(UUID: string, transferActionType: TransferActionTypes): MatDialogRef<CreateTransferCalendarDialogComponent> {
    return this.dialog.open(CreateTransferCalendarDialogComponent,
      {
        disableClose: true,
        autoFocus: true,
        width: '80%',
        maxHeight: '90%', 
        data:  { UUID, transferActionType }
      },
    );
  }

  openCreateTransfer(UUID?: string, transferActionType?: TransferActionTypes, openedByUrl?: boolean): MatDialogRef<CreateTransferDialogComponent>  {
    return this.dialog.open(CreateTransferDialogComponent,
      {
        disableClose: true,
        autoFocus: true,
        width: '80%',
        maxHeight: '90%', 
        data:  { 
          UUID, 
          transferActionType: (transferActionType ? transferActionType : TransferActionTypes.CreateTransfer), 
          openedByUrl: (openedByUrl ? openedByUrl : false) 
        }
      },
    );
  }

  getTransferCalendar(uuid: string): Promise<UdeuTransferCalendar> {
    const path = `smtecno/ssm/deusto/transfer/calendar/${uuid}`;
    const httpMethod = 'GET';
    const pathParams = {};  // No funciona
    const queryParams = {};
    const headerParams = {};
    const formParams = {};
    const bodyParam = {};
    const contentTypes = [];
    const accepts = [];
    const returnType = '';
    const url = 'alfresco/service';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  getTransfer(uuid: string): Promise<UdeuTransfer> {
    const path = `smtecno/ssm/deusto/transfer/${uuid}`;
    const httpMethod = 'GET';
    const pathParams = {};  // No funciona
    const queryParams = {};
    const headerParams = {};
    const formParams = {};
    const bodyParam = {};
    const contentTypes = [];
    const accepts = [];
    const returnType = '';
    const url = 'alfresco/service';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  createCalendar(udeuTransferCalendar: UdeuTransferCalendar): Promise<any> {
    const path = 'smtecno/ssm/deusto/transfer/calendar';
    const httpMethod = 'POST';
    const pathParams = {};
    const queryParams = {};
    const headerParams = {};
    const formParams = {};
    const bodyParam = udeuTransferCalendar;
    const contentTypes = ['application/json'];
    const accepts = [];
    const returnType = '';
    const url = 'alfresco/service';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  updateCalendar(UUID: string, udeuTransferCalendar: UdeuTransferCalendar): Promise<any> {
    const path = `smtecno/ssm/deusto/transfer/calendar/${UUID}`;
    const httpMethod = 'PUT';
    const pathParams = {};  // No funciona
    const queryParams = {};
    const headerParams = {};
    const formParams = {};
    const bodyParam = udeuTransferCalendar;
    const contentTypes = ['application/json'];
    const accepts = [];
    const returnType = '';
    const url = 'alfresco/service';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  createTransfer(udeuCreateTransfer: UdeuCreateTransfer) : Promise<void> {
    const formParam: any = {
      data: JSON.stringify(udeuCreateTransfer.data)
    };

    udeuCreateTransfer.files?.forEach((file) => { 
      const fileId = file.id;
      formParam[fileId] = file.file;
    });

    const path = 'smtecno/ssm/deusto/transfer';
    const httpMethod = 'POST';
    const pathParams = {};
    const queryParams = {};
    const headerParams = {};
    const formParams = formParam;
    const bodyParam = {};
    const contentTypes = ['multipart/form-data'];
    const accepts = ['text/plain'];
    const returnType = '';
    const url = 'alfresco/service';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  updateTransfer(uuid: string, udeuCreateTransfer: UdeuCreateTransfer) : Promise<void> {
    const formParam: any = {
      data: JSON.stringify(udeuCreateTransfer.data)
    };

    udeuCreateTransfer.files?.forEach((file) => { 
      const fileId = file.id;
      formParam[fileId] = file.file;
    });

    const path = `smtecno/ssm/deusto/transfer/${uuid}`;
    const httpMethod = 'PUT';
    const pathParams = {};
    const queryParams = {};
    const headerParams = {};
    const formParams = formParam;
    const bodyParam = {};
    const contentTypes = ['multipart/form-data'];
    const accepts = ['text/plain'];
    const returnType = '';
    const url = 'alfresco/service';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  getRecipientByUuid(recipientUUID: string): Promise<NodePaging> {
    const path = 'search';
    const httpMethod = 'POST';
    const pathParams = {};
    const queryParams = {};
    const headerParams = {};
    const formParams = {};
    const bodyParam = {
      query: {
        language: "afts",
        query: `${SYS_NODE_UUID_PROP}:'${recipientUUID}'`
      },
      include: [
          "properties"
      ]
    };
    const contentTypes = [];
    const accepts = [];
    const returnType = '';
    const url = 'alfresco/api/-default-/public/search/versions/1';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  getDocumentByUuid(documentUUID: string): Promise<NodePaging> {
    const path = 'search';
    const httpMethod = 'POST';
    const pathParams = {};
    const queryParams = {};
    const headerParams = {};
    const formParams = {};
    const bodyParam = {
      query: {
        language: "afts",
        query: `${SYS_NODE_UUID_PROP}:'${documentUUID}'`
      },
      include: [
          "properties"
      ]
    };
    const contentTypes = [];
    const accepts = [];
    const returnType = '';
    const url = 'alfresco/api/-default-/public/search/versions/1';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

}
